"use client";

import { useMemo } from "react";
import { useCurrentLocation } from "@/hooks/use-current-location";
import {
  hrefFromPathnameAndSearch,
  resolveBackHref,
  withFromParam,
} from "@/lib/back-nav";

export function useCurrentHref() {
  const { pathname, searchParams } = useCurrentLocation();
  const searchParamsString = searchParams.toString();

  return useMemo(
    () => hrefFromPathnameAndSearch(pathname, searchParamsString),
    [pathname, searchParamsString],
  );
}

export function useHrefWithFrom(href: string, from?: string | null) {
  const currentHref = useCurrentHref();

  return useMemo(
    () => withFromParam(href, from ?? currentHref),
    [currentHref, from, href],
  );
}

export function useResolvedBackHref(fallbackHref: string) {
  const { searchParams } = useCurrentLocation();
  const fromParam = searchParams.get("from");

  return useMemo(
    () => resolveBackHref(fromParam, fallbackHref),
    [fallbackHref, fromParam],
  );
}
